<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pi_inoutno,pi_vendname,pi_remark"
      placeholder="输入单据编号、供应商、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/purchase/in/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pi_vendname}}</p>
          <p class="list-item-muted">{{item.pi_inoutno}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'" v-if="!isFieldHidden('main.pi_total')">{{item.pi_total}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pi_status!='已审核'}"
          >{{item.pi_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'" v-if="!isFieldHidden('main.pi_total')">{{getTotal('pi_total')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import listCustomization from "@/mixins/listCustomization.js";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list,listCustomization],
  data() {
    return {
      params: {
        caller: 'PurchaseIn',
        name: 'purchase-purchasein-querypanel-MAIN', 
      },
      listUrl: "/api/purchase/prodinout/list",
      filters: [
        {
          type: "date",
          name: "pi_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "pi_class='PURCIN'"
            },
            {
              value: 1,
              label: "待入库",
              condition: "pi_class = 'PURCIN' and pi_statuscode<>'AUDITED'"
            },
            {
              value: 2,
              label: "待对账",
              condition:
                "pi_status='已审核' and pi_class in('采购验收单','采购验退单','PURCIN','PURCOUT') and exists(select 1 from prodiodetail where pd_piid=pi_id and ifnull(apcheckStatus,' ')<>'已对账')"
            },
            {
              value: 3,
              label: "待付款",
              condition:
                "pi_class in('采购验收单','采购验退单','PURCIN','PURCOUT')  and pi_status='已审核' and exists(select 1 from prodiodetail b where b.pd_piid=pi_id and ifnull(b.pd_ordertotal,0)>ifnull(pd_recamount,0))",
              mode: "DETAIL"
            },
            {
              value: 4,
              label: "已入库",
              condition: "pi_class = 'PURCIN' and pi_status='已审核'"
            },
            {
              value: 5,
              label: "已付款",
              condition: "pi_class = 'PURCIN' and pi_prstatus='已核销'"
            }
          ]
        }
      ]
    };
  }
};
</script>